import { render, staticRenderFns } from "./PartTransactionSummary.vue?vue&type=template&id=4824bac2&"
import script from "./PartTransactionSummary.vue?vue&type=script&lang=js&"
export * from "./PartTransactionSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports